
import { Brain, Code, Database, Shield } from "lucide-react";
import NavigationButtons from '@/components/NavigationButtons';

const Solutions = () => {
  return (
    <div className="min-h-screen pt-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-deepseek-secondary">Our Solutions</h1>
        </div>
        <p className="text-xl text-gray-600 mb-12 max-w-3xl">
          Discover our comprehensive suite of AI solutions designed to transform your business and drive innovation.
        </p>
        
        <NavigationButtons />
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mb-4">
              <Brain className="h-6 w-6 text-deepseek-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Machine Learning Solutions</h3>
            <p className="text-gray-600">
              Custom machine learning models tailored to your specific business needs, from predictive analytics to pattern recognition.
            </p>
          </div>
          
          <div className="p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mb-4">
              <Code className="h-6 w-6 text-deepseek-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Natural Language Processing</h3>
            <p className="text-gray-600">
              Advanced NLP capabilities for text analysis, sentiment analysis, and automated content generation.
            </p>
          </div>
          
          <div className="p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mb-4">
              <Database className="h-6 w-6 text-deepseek-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Big Data Analytics</h3>
            <p className="text-gray-600">
              Transform your data into actionable insights with our advanced analytics and visualization tools.
            </p>
          </div>
          
          <div className="p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mb-4">
              <Shield className="h-6 w-6 text-deepseek-primary" />
            </div>
            <h3 className="text-xl font-semibold mb-3">AI Security</h3>
            <p className="text-gray-600">
              Protect your AI systems with our comprehensive security solutions and best practices implementation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
